import { EventEmitter } from '@angular/core';
import { of, BehaviorSubject } from 'rxjs';
import { untilDestroyed } from 'ngx-take-until-destroy';
var BaseStep = /** @class */ (function () {
    function BaseStep(stepStateService, changeDetectorRef) {
        var _this = this;
        this.stepStateService = stepStateService;
        this.changeDetectorRef = changeDetectorRef;
        this.changes = new EventEmitter();
        this._contextChanges = new BehaviorSubject(null);
        this.contextChanges = this._contextChanges.asObservable();
        this._isValid = false;
        this.nextStepClick = function () { };
        this.stepStateService.stateChanges
            .pipe(untilDestroyed(this))
            .subscribe(function (p) {
            _this.changeDetectorRef.markForCheck();
        });
    }
    Object.defineProperty(BaseStep.prototype, "context", {
        get: function () {
            return this._context;
        },
        set: function (value) {
            this._context = value;
            this._contextChanges.next(value);
        },
        enumerable: true,
        configurable: true
    });
    ;
    BaseStep.prototype.saveChanges = function (options) {
        if (options === void 0) { options = {}; }
    };
    Object.defineProperty(BaseStep.prototype, "isValid", {
        get: function () {
            return this._isValid;
        },
        enumerable: true,
        configurable: true
    });
    BaseStep.prototype.markAsValid = function () {
        this._isValid = true;
        this.changes.emit(this._isValid);
    };
    BaseStep.prototype.markAsInvalid = function () {
        this._isValid = false;
        this.changes.emit(this._isValid);
    };
    BaseStep.prototype.activateStep = function () {
        this.changes.emit(this.isValid);
    };
    BaseStep.prototype.deactivateStep = function () { };
    BaseStep.prototype.getNextStep = function () {
        return null;
    };
    BaseStep.prototype.isStepComplete = function () {
        return of(true);
    };
    BaseStep.prototype.ngOnDestroy = function () { };
    BaseStep.prototype.registerNextStep = function (fn) {
        this.nextStepClick = fn;
    };
    BaseStep.InputProperties = ['step'];
    BaseStep.OutputProperties = ['changes'];
    return BaseStep;
}());
export { BaseStep };
